import NavigationBar from '../NavigationBar/NavigationBar.js';
import BottomHeader from '../BottomHeader/BottomHeader.js';
import './Page.css';

const Page = ({mainSection}) => {
    return (
        <div className='Page'>
            <div className="Page-Background">
                <NavigationBar />
                {mainSection}
                <BottomHeader />
            </div>
        </div>
    );
}

export default Page;